import React from "react";
import { TournamentMinimal } from "../../../client/api";
import { IDType, MatchSmallElement } from "../../../config/types";
import MatchTile from "../Match/MatchTile";
import CupSmall from "../Cup";

export type SectionItem =
  | string
  | (MatchSmallElement & { idx: number; idx2: number })
  | TournamentMinimal;

export type SectionTitle = { name: string; id: IDType | undefined };

export type Section = { title: SectionTitle; data: SectionItem[] };

const LeagueMatch: React.FC<{
  item: SectionItem;
  showLeagueBanner?: boolean;
  matchBanner?: "none" | "date-league" | "league-only";
  isMainLeagueOverride?: (match: MatchSmallElement) => boolean | undefined;
}> = ({
        item,
        showLeagueBanner,
        matchBanner,
        isMainLeagueOverride
      }) => {
  if (typeof item === "string") {
    return null;
  }

  if ("dateFrom" in item) {
    return <CupSmall cup={item} />;
  }

  const banner =
    matchBanner ?? (showLeagueBanner ? "league-only" : "none");

  return (
    <MatchTile
      match={item}
      banner={banner}
      isMainLeagueOverride={isMainLeagueOverride?.(item)}
    />
  );
};

const LeagueMatchSection: React.FC<{
  section: Section;
  showLeagueBanner?: boolean;
  matchBanner?: "none" | "date-league" | "league-only";
  isMainLeagueOverride?: (match: MatchSmallElement) => boolean | undefined;
}> = ({
        section,
        showLeagueBanner,
        matchBanner,
        isMainLeagueOverride
      }) => (
  <>
    {section.data.map((item) => (
      <LeagueMatch
        item={item}
        showLeagueBanner={showLeagueBanner}
        matchBanner={matchBanner}
        isMainLeagueOverride={isMainLeagueOverride}
        key={`league-match-item-${typeof item === "string" ? item : item.id}`}
      />
    ))}
  </>
);

export default LeagueMatchSection;
